import styled from 'styled-components';

import { InputSearch } from 'ui/inputs';

import { FormGridAreas } from '../../types';
import { LOOKUP_TYPE_TO_HUMAN_READABLE_NAME } from '../../constant';
import { useFormContext } from '../../contexts/FormContext';

const Wrapper = styled.div`
  grid-area: ${FormGridAreas.identifierInput};
`;

export const IdentifierInput = () => {
  const { setIdentifier, identifier, isSubmitting, lookupType } = useFormContext();
  return (
    <Wrapper>
      <InputSearch
        id="contact-lookup--identifier-input"
        onChange={setIdentifier}
        placeholder={LOOKUP_TYPE_TO_HUMAN_READABLE_NAME[lookupType]}
        value={identifier}
        isDisabled={isSubmitting}
      />
    </Wrapper>
  );
};
